import { gql } from '@apollo/client';

export const NEW_ANIMAL = gql`
  fragment NewAnimal on Animal {
    id
  }
`;
